<template>
  <div class="prj__page">
    <logo :status="'page'" />
    <div class="page__content" v-if="loading">
      <h1 class="title">{{ dbContent.data.title[0].text }}</h1>
      <h2 class="intro">{{ dbContent.data.text_intro }}</h2>
      <SliceZone
        v-if="loading"
        :slices="dbContent.data.body"
        :resolver="({ sliceName }) => slices[sliceName]"
      />
      <div v-if="loading" class="ctrl__container">
        <div class="ctrl__left">
          <a :href="'/prj/' + backCode" v-if="backCode"
            ><img id="left" src="../assets/img/tempelli-carret-r.svg" alt="" />
            <div>Previous</div></a
          >
        </div>
        <div class="ctrl__right">
          <a :href="'/prj/' +nextCode" v-if="nextCode"
            ><div>Next</div>
            <img id="right" src="../assets/img/tempelli-carret-r.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SliceZone from "vue-slicezone";
import Logo from "../components/Logo.vue";
import PrjHero from "../components/slices/PrjHero.vue";
import PrjParagraph from "../components/slices/PrjParagraph.vue";
import PrjFull from "../components/slices/PrjFull.vue";
import PrjDouble from "../components/slices/PrjDouble.vue";
import CenterImage from "../components/slices/CenterImage.vue";
import PrjCredits from "../components/slices/PrjCredits.vue";

export default {
  components: {
    SliceZone,
    Logo,
  },
  data() {
    return {
      loading: false,
      slices: {
        PrjHero,
        PrjParagraph,
        PrjFull,
        PrjDouble,
        CenterImage,
        PrjCredits,
      },
      dbContent: "",
      nextCode: "",
      backCode: "",
    };
  },
  methods: {
    async getPrj(prj) {
      const response = await this.$prismic.client.getByUID("project", prj);
      console.log("DIocdddhdhdhdh")
      if (!response) this.$router.replace("/404");
      this.dbContent = response;
      this.loading = true;
      const prev = await this.$prismic.client.query(
        this.$prismic.Predicates.at("document.type", "project"),
        {
          pageSize: 1,
          after: `${response.id}`,
          orderings: "[document.last_publication_date desc]",
        }
      );
      const succ = await this.$prismic.client.query(
        this.$prismic.Predicates.at("document.type", "project"),
        {
          pageSize: 1,
          after: `${response.id}`,
          // orderings: "[my.project.uid]",
        }
      );
      this.backCode = prev.results[0]?.uid;

      this.nextCode = succ.results[0]?.uid;
    },
  },
  created() {
    // Call the API query method
    this.getPrj(this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
.prj__page {
  color: white;
  background: black;
  min-height: 100vh;
}

.page__content {
  width: 100%;
  padding-top: 8.2vw;
  padding-bottom: 32px;
}

.title {
  margin: 0 20vw;
  font-family: Lausanne, Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 16px;
  @media screen and (max-width: 767px) {
    margin: 0 20px 0 20px;
  }
}
.intro {
  margin: 22px 20vw;
  font-family: Lausanne, Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 46px;
  line-height: 109%;
  margin-bottom: 42px;
  @media screen and (max-width: 767px) {
    margin: 32px 20px 32px 20px;
    font-size: 28px;
    line-height: 140%;
  }
}

.ctrl__container {
  display: flex;
  justify-content: space-between;
  margin: 100px 20vw;
  padding-bottom: 52px;
  a {
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    font-family: Lausanne, Arial, Helvetica, sans-serif;
    text-decoration: none;
    font-size: 28px;
    img{
      transition: 200ms ease-out;
    }

    &:hover{
      text-decoration: underline;
      #left{
        transform: translate(-5px, 0);
      }
      #right{
        transform: translate(5px, 0) rotate(180deg);
      }
    }
  }

      #right {
      transform: rotate(180deg);
    }
    @media screen and (max-width: 767px) {
      margin: 100px 20px;
    }
}
</style>
